/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { Field } from 'react-final-form';
import { Text } from '@blend/enterprise-components';

import { respondToAuthChallenge } from 'id-api/auth';
import { FormCard } from 'id-components/FormCard';
import { useLoginFlowSubmit, useChallengeCookie } from 'id-utils/login';
import { getConfirmationCodeInputConfig } from 'id-utils/inputs';

// used by calipers
const ID_PHONE_MFA = 'it-PhoneMFA';

const confirmationCodeInputConfig = getConfirmationCodeInputConfig({ name: 'mfaCode' });

export const PhoneMFAPage: React.FC = () => {
  const onSubmit = useLoginFlowSubmit(respondToAuthChallenge);
  const challengeCookieResult = useChallengeCookie();
  const returnToMFASetupSupported =
    !!challengeCookieResult.cookie && challengeCookieResult.cookie?.returnToMFASetupSupported;
  const last4Digits = (() => {
    if (challengeCookieResult.type === 'failure' || challengeCookieResult.cookie?.challengeName !== 'SMS_MFA') {
      return null;
    }
    return challengeCookieResult.cookie.meta?.phoneNumberLastFour;
  })();

  return (
    <FormCard<Identity.API.MFAChallenge>
      headerLabel={
        <Text>
          A text message with your code has been sent to the phone number ending with{' '}
          <Text weight="semibold">{last4Digits}</Text>
        </Text>
      }
      headerTitle="Enter verification code"
      id={ID_PHONE_MFA}
      onSubmit={onSubmit}
      cancelLabel={returnToMFASetupSupported ? 'Back' : 'Cancel'}
      submitLabel="Log in"
    >
      <Field {...confirmationCodeInputConfig} />
      {returnToMFASetupSupported && (
        <Text fontSize="sm" weight="medium">
          If you have entered the wrong phone number or need to change your verification method, press 'Back'.
        </Text>
      )}
    </FormCard>
  );
};
